"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var react_1 = __importDefault(require("react"));
var Action_1 = require("../../Services/Redux/Action");
var ErrorReportingFlow_1 = require("./ErrorReporting/ErrorReportingFlow");
var mapStateToProps = function (state) { return ({
    authenticatedUser: state.authentication.user,
    globalErrors: state.globalErrors
}); };
var mapDispatchToProps = {
    clearError: Action_1.clearErrorAction
};
var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var GlobalErrorHandler = function (props) {
    var authenticatedUser = props.authenticatedUser, homePagePath = props.homePagePath, globalErrors = props.globalErrors, clearError = props.clearError, children = props.children, webAppName = props.webAppName, webAppVersion = props.webAppVersion, backgroundPicture = props.backgroundPicture, traceClientApiConfig = props.traceClientApiConfig;
    var hasError = (globalErrors.errorApi !== undefined) || (globalErrors.errorJS !== undefined);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        hasError && (react_1.default.createElement(ErrorReportingFlow_1.ErrorReportingFlow, { reportImmediatly: globalErrors.reportImmediatly, onFlowTerminated: function (hasTraced, goBackHome) {
                if (hasTraced) {
                    var val = localStorage.getItem('ErrorReportingCount');
                    var count = val ? Number.parseInt(val, 10) : 0;
                    localStorage.setItem('ErrorReportingCount', (count + 1).toString());
                }
                clearError();
                if (goBackHome) {
                    window.location.href = homePagePath;
                }
            }, backgroundPicture: backgroundPicture, errorApi: globalErrors.errorApi, errorJS: globalErrors.errorJS, webAppName: webAppName, webAppVersion: webAppVersion, traceClientApiConfig: traceClientApiConfig, authenticatedUser: authenticatedUser }))));
};
exports.default = connector(GlobalErrorHandler);
//# sourceMappingURL=GlobalErrorHandler.js.map